import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    if (this.element.tomselect) return;

    this.tomSelect = new TomSelect(this.element, {
      create: false,
      onChange: () => {
        if (this.element.getAttribute("multiple") === "multiple") return;

        this.tomSelect.close();
        this.tomSelect.blur();
      }
    });
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }

    if (this.element.tomselect) {
      this.element.tomselect = null;
    }

    this.tomSelect = null;
  }
}
